module.exports = __webpack_public_path__ + "static/media/size5.f5b21ce4.svg";